require('./contractLoanPdfViewer.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
// Commons components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const contractPreGrantedCredit = require('../../../actions/contractPreGrantedCredit');
// @Components
const ContractLoanPdfViewerError = require('../contractLoanPdfViewerError/contractLoanPdfViewerError');
// constants
const { LOAN_PDF_TIMEOUT } = require('../../../loansConstants/index');
// helpers
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');

class ContractLoanPdfViewer extends React.Component {
    constructor(props) {
        super(props);

        this.state = { show: false, isPdfReeded: false };
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
    }

    componentDidMount() {
        // Small delay when the documents are loaded already
        setTimeout(() => {
            this.setState({ show: true });
        }, LOAN_PDF_TIMEOUT);
    }

    handleOnPrintDocument() {
        const { onPrint, document, taggingOnPrint } = this.props;

        if (document) {
            openBase64pdfInPrintWindow(document);
        }
        (isPrintOfficeMode()) && onPrint(document);
        taggingOnPrint();
    }

    getPoeditorPrefix() {
        return 'contractLoanPdfViewer';
    }

    handleDocumentReaded() {
        const { checkReadDocument, checkReadDocumentPolicy } = this.props;
        this.setState({ isPdfReeded: true });
        checkReadDocument()
        checkReadDocumentPolicy && checkReadDocumentPolicy()
    }

    buildViewer() {
        const {
            document,
            errorLoading,
            getDocuments,
            onDownload,
            scale,
            title,
            viewerHeight,
            isModal
        } = this.props;

        return (
            <div className="contract-loan-pdf-viewer__document">
                <OKPdfViewer
                    onDownload={onDownload}
                    onPrint={this.handleOnPrintDocument}
                    pdfFile={document}
                    title={title}
                    scale={scale}
                    infiniteScroll={false}
                    isModal={isModal}
                    failedLoadingPdf={errorLoading}
                    displayScrollButton
                    errorComponent={() => {
                        return <ContractLoanPdfViewerError getDocuments={getDocuments} />
                    }}
                    viewerHeight={viewerHeight}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            </div>
        );
    }

    buildCheckbox() {
        const {
            agreeCheckbox,
            checkboxLabel,
            errorLoading,
            hasSignaturePattern,
            immSignaturePattern,
            isCallingDownloadService,
            isLoading,
            onAgreeCheckbox,
            validate,
            checkboxFlag,
            showOfficeCheckBox
        } = this.props;

        const errorState = (validate && !agreeCheckbox);
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const signaturePatternLoading = (
            immSignaturePattern.get('isFetchingConfig') ||
            immSignaturePattern.get('isFetchingSMSCode') ||
            immSignaturePattern.get('isFetchingSignaturePassCode') ||
            immSignaturePattern.get('callbackCalled')
        );
        const loadingOTP = hasSignaturePattern && signaturePatternLoading;
        const checkbox = !isLoading && !isCallingDownloadService ? (
            <OKCheckbox
                extraClass="contract-loan-pdf-viewer__checkbox"
                disabled={loadingOTP || checkboxFlag}
                errorMessage={errorMessage}
                errorState={errorState}
                idName="contract-loan-pdf-viewer-checkbox"
                label={checkboxLabel}
                onChange={onAgreeCheckbox}
                value={agreeCheckbox || checkboxFlag}
            />
        ) : <LoadingSection />;

        const cccheckbox = (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                {checkbox}
            </BlockInfo>
        );

        const component = __CONTACT_CENTER__ && isPrintOfficeMode() ? null : __CONTACT_CENTER__ && !isPrintOfficeMode() ? cccheckbox : checkbox;

        return !errorLoading ? showOfficeCheckBox ? checkbox : component : null;
    }

    buildDownloadError() {
        const { downloadError } = this.props;
        const poeditorPrefix = this.getPoeditorPrefix();
        const errorMessage = `${poeditorPrefix}-${poeditorPrefix}_downloadError`;

        return downloadError ? (
            <div>
                <FormattedText className="contract-loan-pdf-viewer__not-readed-error" value={errorMessage} />
            </div>
        ) : null;
    }

    buildLoadingDownload() {
        const { loadingDownload } = this.props;

        return loadingDownload ? (
            <LoadingSection />
        ) : null;
    }

    render() {
        const { show, isPdfReeded } = this.state;
        const { isLoading, isModal, className, checkboxShow, checkboxFlag } = this.props;
        const viewer = isLoading ? <LoadingSection /> : this.buildViewer();
        const checkbox = (checkboxShow === undefined && (isPdfReeded || checkboxFlag)) ? this.buildCheckbox() : null;
        const downloadErrorMessage = this.buildDownloadError();
        const loadingDownloadSpinner = this.buildLoadingDownload();
        const classNameContainer = classNames('contract-loan-pdf-viewer', className);
        const classNameParent = classNames({
            'col-md-12 col-lg-12 contract-loan-pdf-viewer__pdf-viewer': isModal
        });

        return show ? (
            <div className={classNameContainer}>
                <div className={classNameParent}>
                    {viewer}
                </div>
                {checkbox}
                {downloadErrorMessage}
                {loadingDownloadSpinner}
            </div>
        ) : null;
    }
}

ContractLoanPdfViewer.propTypes = {
    agreeCheckbox: PropTypes.bool,
    checkboxLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    className: PropTypes.string,
    document: PropTypes.object,
    downloadError: PropTypes.bool,
    errorLoading: PropTypes.bool.isRequired,
    getDocuments: PropTypes.func.isRequired,
    hasSignaturePattern: PropTypes.bool,
    immSignaturePattern: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isCallingDownloadService: PropTypes.bool,
    isModal: PropTypes.bool,
    loadingDownload: PropTypes.bool,
    onAgreeCheckbox: PropTypes.func,
    onDownload: PropTypes.func,
    onPrint: PropTypes.func,
    scale: PropTypes.number,
    title: PropTypes.string,
    validate: PropTypes.bool,
    viewerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkboxFlag: PropTypes.bool,
    showOfficeCheckBox: PropTypes.bool,
    taggingOnPrint: PropTypes.func,
};

ContractLoanPdfViewer.defaultProps = {
    isCallingDownloadService: false,
    scale: 1.1,
    isModal: false,
    checkboxFlag: false,
    showOfficeCheckBox: false,
    taggingOnPrint: () => { },
};

module.exports = ContractLoanPdfViewer;
module.exports.ContractLoanPdfViewer = connect(state => ({
    immSignaturePattern: state.signaturePattern,
}),
    {
        checkReadDocument: contractPreGrantedCredit.checkReadDocument
    }
)(ContractLoanPdfViewer);
